module.exports = "/static/media/LOGOOPTICAB.png"